import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/sit-a/bd-mobile-next/app/components/global/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/sit-a/bd-mobile-next/app/components/global/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/home/crazysal/sit-a/bd-mobile-next/app/components/global/ReduxProvider.tsx");
